import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "react-bootstrap";
import { setSelectedItem } from "../../../redux/slices/tbdSlice";
import { useNavigate } from "react-router-dom";

const formatColumnName = (name) => {
  return String(name || '')
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z])([A-Z])/g, "$1 $2");
};

const Tbd = () => {
  const tbdAuditItems = useSelector((state) => state.tbd?.fullJobAuditItems);
  const jobId = useSelector((state) => state.jobId.jobId);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filteredTbdList = useMemo(() => {
    const source = tbdAuditItems || [];
    return source.filter((tbdItem) => String(tbdItem.ProjectID) === String(jobId));
  }, [tbdAuditItems, jobId]);

  const handleRowClick = (tbdItem) => {
    if (!tbdItem.Page) return;
    dispatch(setSelectedItem(tbdItem));
    let page = tbdItem.Page.toLowerCase();
    switch (page) {
      case 'mechanical':
        page = 'mechInfo';
        break;
      case 'electrical':
        page = 'elecInfo';
        break;
      case 'general':
        page = 'generalInfo';
        break;
      case 'sales information':
        page = 'salesInfo';
        break;
      default:
        page = `${page}info`;
    }
    navigate(`/${jobId}/${page}`, { state: { tbdItem } });
  };

  return (
    <div className="additional-tbd-table-shell">
      <Table striped bordered hover className="additional-tbd-table">
        <thead>
          <tr>
            <th>Page</th>
            <th>Section</th>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {filteredTbdList.map((tbdItem, index) => (
            <tr
              key={index}
              onClick={() => handleRowClick(tbdItem)}
              className="additional-tbd-row"
              style={{ cursor: tbdItem.Page ? 'pointer' : 'default' }}
            >
              <td data-label="Page">{tbdItem.Page || '—'}</td>
              <td data-label="Section">{formatColumnName(tbdItem.Table) || '—'}</td>
              <td data-label="Field">{formatColumnName(tbdItem.ColumnName)}</td>
              <td data-label="Value">{tbdItem.Value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Tbd;
